export const setThousandPoints = (value: string | number | undefined | null, separator = '.') =>
  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
